import {createContext} from 'react';

export const ButtonContext = createContext({
    size: null,
    disabled: null,
});
